import { createFileRoute } from '@tanstack/react-router';
import Confetti from 'react-confetti';
import TablerIconHome from '~icons/tabler/home';

import { Card, Typography } from 'gooey';
import { Img } from '#/components/images';
import { ButtonLink } from '#/components/links';
import fx from '#/fx';
import { ClientOnly } from '#/lib/client-only';
import { Content, pageSEO } from '#/lib/content';
import { cn } from '#/utils/classnames';

export const Route = createFileRoute('/_blank/booking_/$id/confirmation')({
  loader: async ({ params }) => {
    const page = await fx.getPageContentBySlug({
      data: {
        key: 'booking',
        slug: params.id,
      },
    });

    return { page };
  },
  head: ({ loaderData, match }) => {
    return {
      meta: pageSEO(
        {
          title: 'Confirmed Booking',
          description: 'Your booking has been confirmed.',
          keywords: ['booking', 'meeting', 'confirmed', 'calendly'],
        },
        match,
        loaderData?.page
      ),
    };
  },
  component: BookingConfirmationPage,
});

function BookingConfirmationPage() {
  const { page } = Route.useLoaderData();
  return (
    <div
      className={cn('w-screen h-screen bg-black', 'flex items-center justify-center', 'md:p-16')}
    >
      <Card
        className={cn(
          'backdrop-opacity-30 backdrop-invert w-[90vw] max-w-[800px] bg-black/90 relative z-10 text-center',
          'px-4 py-6 md:px-12 md:py-12 mx-auto'
        )}
      >
        <Img
          location='static'
          className='max-w-72 mb-8 mx-auto'
          src={page.sections.booking.confirmation.image.src}
          height={page.sections.booking.confirmation.image.height}
          width={page.sections.booking.confirmation.image.width}
          alt='Happy Duck'
          responsive
        />
        <Typography variant='h1' gutterBottom>
          <Content content={page.sections.booking.confirmation.title} />
        </Typography>
        <Typography variant='h5' component='p' className='[&_a]:link [&_a]:link-primary'>
          <Content content={page.sections.booking.confirmation.subtitle} />
        </Typography>
        {(
          [
            { className: 'sm:hidden md:hidden mt-6', size: 'medium' },
            { className: 'hidden sm:flex md:hidden mt-10', size: 'large' },
            { className: 'hidden md:flex mt-16 ', size: 'xlarge' },
          ] as const
        ).map((btnProps) => (
          <ButtonLink
            key={btnProps.size}
            startIcon={<TablerIconHome />}
            to='/'
            variant='contained'
            color='primary'
            className={cn('w-fit mx-auto', btnProps.className)}
            size={btnProps.size}
          >
            Go back to the homepage
          </ButtonLink>
        ))}
      </Card>
      <ClientOnly>{() => <Confetti className='z-0' />}</ClientOnly>
    </div>
  );
}
